module.exports = __webpack_public_path__ + "img/eventdetail_not.d1f2beff.png";